import {closeCurrentDialog, Form, FormSubmitHandler, showNotification} from 'platform/components';

import {useRemapCustomMakeMutation} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {CustomCatalogueMakeGroup, getMakeGroupKey} from '../utils/groupUsageByMake';
import {
  KEEP_ORIGINAL_MODEL_FAMILY,
  remapMakeFormSchema,
  RemapMakeFormValues,
} from '../utils/remapMakeFormSchema';
import {RemapMakeFormContent} from './RemapMakeFormContent';

interface RemapMakeDialogProps extends RequiredTestIdProps {
  group: CustomCatalogueMakeGroup;
  onSubmitted: (key: string) => void;
}

export function RemapMakeDialog(props: RemapMakeDialogProps) {
  const [remapCustomMake] = useRemapCustomMakeMutation();

  const defaultValues: RemapMakeFormValues = {
    targetMake: '',
    modelFamilyMapping: props.group.models.map((model) => ({
      modelFamily: model.modelFamily,
      targetModelFamily: '',
    })),
  };

  const handleSubmit: FormSubmitHandler<RemapMakeFormValues> = (values) =>
    remapCustomMake({
      vehicleType: props.group.vehicleType,
      make: props.group.make,
      targetMake: values.targetMake,
      modelFamilyMapping: values.modelFamilyMapping.map((item) => ({
        modelFamily: item.modelFamily,
        targetModelFamily:
          item.targetModelFamily === KEEP_ORIGINAL_MODEL_FAMILY ? null : item.targetModelFamily,
      })),
    })
      .unwrap()
      .then(() => {
        closeCurrentDialog();
        // 202 Accepted: nothing is done yet and no count is known - the toast reports both.
        props.onSubmitted(getMakeGroupKey(props.group));
        showNotification.info(i18n.t('entity.customCatalogue.notifications.replacementInProgress'));
      })
      .catch(handleApiError);

  return (
    <Form<RemapMakeFormValues>
      experimentalZodSchema={remapMakeFormSchema}
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
    >
      {(control, formApi) => (
        <RemapMakeFormContent
          control={control}
          formApi={formApi}
          group={props.group}
          data-testid={suffixTestId('form', props)}
        />
      )}
    </Form>
  );
}
